require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./flyout"), require("./menu"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./flyout", "./menu"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./flyout"), require("./menu")) : factory(root["./utils"], root["./flyout"], root["./menu"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__28__, __WEBPACK_EXTERNAL_MODULE__38__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[17],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(215);


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ContextMenu = _interopRequireDefault(__webpack_require__(216));

exports["default"] = _ContextMenu["default"];
exports.ContextMenu = _ContextMenu["default"];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _flyout = __webpack_require__(28);

var _utils = __webpack_require__(4);

var _menu = _interopRequireDefault(__webpack_require__(38));

var _ContextMenu = _interopRequireDefault(__webpack_require__(217));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var contextMenuClassName = _ContextMenu["default"].menuClassName.replace(/"/g, '');

var candidatePlacement = ['left', 'top', 'bottom', 'right', 'topLeft', 'bottomLeft', 'topRight', 'bottomRight'];
var sanitize = _utils.propsUtils.sanitize;
/** The Context menu is built on top of `<Flyout>`, inheriting much functionality from it.  As such, some of the same properties are made available to context menu as well. */

var ContextMenu = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ContextMenu, _Component);

  function ContextMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (name, item, isDisabled) {
      var onChange = _this.props.onChange;
      onChange && onChange(name, item, isDisabled);
    });
    return _this;
  }

  ContextMenu.Spacer = function Spacer(props) {
    return /*#__PURE__*/_react["default"].createElement(_menu["default"].Spacer, props);
  };

  ContextMenu.Separator = function Separator(props) {
    return /*#__PURE__*/_react["default"].createElement(_menu["default"].Separator, props);
  };

  ContextMenu.List = function List(props) {
    return /*#__PURE__*/_react["default"].createElement(_menu["default"].List, props);
  };

  ContextMenu.Radio = function Radio(props) {
    return /*#__PURE__*/_react["default"].createElement(_menu["default"].Radio, props);
  };

  ContextMenu.Checkbox = function Checkbox(props) {
    return /*#__PURE__*/_react["default"].createElement(_menu["default"].Checkbox, props);
  };

  ContextMenu.ToggleSwitch = function ToggleSwitch(props) {
    return /*#__PURE__*/_react["default"].createElement(_menu["default"].ToggleSwitch, props);
  };

  ContextMenu.Accordion = function Accordion(props) {
    return /*#__PURE__*/_react["default"].createElement(_menu["default"].Accordion, props);
  };

  var _proto = ContextMenu.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        align = _this$props.align,
        triggerNode = _this$props.triggerNode,
        theme = _this$props.theme,
        onClose = _this$props.onClose,
        fixedPosition = _this$props.fixedPosition,
        domNodeToAttachTo = _this$props.domNodeToAttachTo,
        className = _this$props.className,
        children = _this$props.children,
        selected = _this$props.selected,
        menuExtraOptions = _this$props.menuExtraOptions,
        startingFocusIndex = _this$props.startingFocusIndex,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["align", "triggerNode", "theme", "onClose", "fixedPosition", "domNodeToAttachTo", "className", "children", "selected", "menuExtraOptions", "startingFocusIndex"]);
    var classNames = (0, _utils.classnames)(contextMenuClassName);
    var _this$props2 = this.props,
        placement = _this$props2.placement,
        style = _this$props2.style;
    var alignStyles = {};

    if (triggerNode && align && (align === 'left' || align === 'right')) {
      var bodyRect = document.body.getBoundingClientRect();
      var contextRect = triggerNode.getBoundingClientRect();
      var offsetTop = Math.abs(bodyRect.top - contextRect.top) + contextRect.height;
      var offsetRight = Math.abs(bodyRect.right - contextRect.right);

      switch (align) {
        case 'left':
          candidatePlacement = [];
          placement = 'bottomRight';
          alignStyles = {
            left: contextRect.left,
            top: offsetTop
          };
          break;

        case 'right':
          candidatePlacement = [];
          placement = 'bottomLeft';
          alignStyles = {
            right: offsetRight,
            left: null,
            top: offsetTop
          };
          break;

        default:
          break;
      }
    }

    style = (0, _extends2["default"])({}, alignStyles, {
      width: 'auto',
      minWidth: '200px'
    }, style);
    var flyoutProps = (0, _extends2["default"])({}, sanitize(others, ContextMenu), {
      placement: placement,
      hideArrow: true,
      className: classNames + " " + className,
      offset: 8,
      // 8 pixel distance for the context menu defined by design
      fixedPosition: fixedPosition,
      triggerNode: triggerNode,
      onClose: onClose,
      domNodeToAttachTo: domNodeToAttachTo,
      style: style,
      candidatePlacement: candidatePlacement,
      startingFocusIndex: startingFocusIndex
    });
    var menuClassName = (0, _utils.classnames)({
      contextMenu: true
    });
    var menuProps = (0, _extends2["default"])({
      'data-tid': 'ba-common-contextmenu__menu'
    }, sanitize(menuExtraOptions, ContextMenu), {
      className: menuClassName,
      selected: selected,
      onChange: this._onChange
    });

    var menu = /*#__PURE__*/_react["default"].createElement(_menu["default"], menuProps, children);

    var contextFlyout = /*#__PURE__*/_react["default"].createElement(_flyout.ContextFlyout, (0, _extends2["default"])({}, flyoutProps, {
      ref: function ref(node) {
        _this2._contextMenu = node;
      }
    }), menu);

    var normalFlyout = /*#__PURE__*/_react["default"].createElement(_flyout.Flyout, (0, _extends2["default"])({}, flyoutProps, {
      ref: function ref(node) {
        _this2._contextMenu = node;
      }
    }), menu);

    return theme ? contextFlyout : normalFlyout;
  };

  return ContextMenu;
}(_react.Component);

exports["default"] = ContextMenu;
(0, _defineProperty2["default"])(ContextMenu, "propTypes", {
  /** Where the Context Menu will be positioned visually off of the triggerNode. customPropTypes: ['top', 'bottom', 'left', 'right'] */
  placement: _propTypes["default"].oneOfType([function (props, propName, componentName) {
    var value = props[propName];

    switch (value) {
      case 'left':
        console.error(new Error("'" + value + "' supplied to '" + propName + "' in '" + componentName + "' is deprecated. It will be removed in Sprint 39.1, use 'topLeft' or 'bottomLeft' instead")); // eslint-disable-line no-console

        break;

      case 'right':
        console.error(new Error("'" + value + "' supplied to '" + propName + "' in '" + componentName + "' is deprecated. It will be removed in Sprint 39.1, use 'bottomRight' or 'topRight' instead")); // eslint-disable-line no-console

        break;

      case 'top':
        console.error(new Error("'" + value + "' supplied to '" + propName + "' in '" + componentName + "' is deprecated. It will be removed in Sprint 39.1, use 'topLeft' or 'topRight' instead")); // eslint-disable-line no-console

        break;

      case 'bottom':
        console.error(new Error("'" + value + "' supplied to '" + propName + "' in '" + componentName + "' is deprecated. It will be removed in Sprint 39.1, use 'bottomLeft' or 'bottomRight' instead")); // eslint-disable-line no-console

        break;

      default:
    }

    return null;
  }, _propTypes["default"].oneOf(candidatePlacement)]),

  /** Node that the Context Menu will visually position itself off of */
  triggerNode: _propTypes["default"].instanceOf(Element),

  /** DOM node that the Context Menu will be attached to in the DOM */
  domNodeToAttachTo: _propTypes["default"].instanceOf(Element),

  /** Function that is called when a value in the Context Menu changes (name and value are arguments) */
  onChange: _propTypes["default"].func,

  /** Option to use context to grab the toolkit theme */
  theme: _propTypes["default"].bool,

  /** Function to be called when a click outside of the Context Menu or triggerNode occurs */
  onClose: _propTypes["default"].func,

  /** Class name to be given to the container of Context Menu */
  className: _propTypes["default"].string,

  /** Object that defines which items from each sub-component are selected */
  selected: _propTypes["default"].object,

  /** Sub-components of Context Menu to display (i.e. ContextMenu.List, ContextMenu.Radio, etc.) */
  children: _propTypes["default"].node,

  /** Custom css styles */
  style: _propTypes["default"].object,

  /** Extra options for the menu */
  menuExtraOptions: _propTypes["default"].object,

  /** left/right aligns the context menu to the trigger node */
  align: _propTypes["default"].oneOf(['left', 'right']),

  /** Flyout.propTypes.fixedPosition */
  fixedPosition: _flyout.Flyout.propTypes.fixedPosition,

  /** Focus index for flyout */
  startingFocusIndex: _propTypes["default"].number
});
(0, _defineProperty2["default"])(ContextMenu, "defaultProps", {
  placement: 'bottomRight',
  className: '',
  style: {},
  menuExtraOptions: {},
  startingFocusIndex: 0
});

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(218);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-context-menu.ba-common-flyout__container{width:200px}.ba-common-context-menu .ba-common-separator{margin:0px;border-color:#e0e0e0}.ba-common-context-menu__wrapper{max-height:480px;overflow:auto}.ba-common-context-menu__wrapper .ba-common-context-menu__icon{display:flex;margin-right:8px}.ba-common-context-menu__wrapper .ba-common-context-menu__item{padding:0 16px 0 12px;font-size:.875rem;height:40px;display:flex;align-items:center;cursor:pointer;border-left-width:4px}.ba-common-context-menu__wrapper .ba-common-context-menu__item .ba-common-toolTip{width:100%}.ba-common-context-menu__wrapper .ba-common-context-menu__item--text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ba-common-context-menu__wrapper .ba-common-context-menu__item--text .cursor{cursor:pointer}.ba-common-context-menu .ba-common-toggleSwitch{margin:8px 0}.ba-common-context-menu .ba-common-toggleSwitch.is-small{margin:12px 0}\n", ""]);

// exports
exports.locals = {
	"menuClassName": "\"ba-common-context-menu\""
};

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__28__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__38__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[214,0]]]);
});